import { render, staticRenderFns } from "./TransferHistory.vue?vue&type=template&id=18fa0a8c&"
import script from "./TransferHistory.vue?vue&type=script&lang=js&"
export * from "./TransferHistory.vue?vue&type=script&lang=js&"
import style0 from "./TransferHistory.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports